import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { ref: "picture" }
const _hoisted_2 = ["type", "data-srcset"]
const _hoisted_3 = ["type", "data-srcset"]
const _hoisted_4 = ["data-src", "alt", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("picture", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formats, (format) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: format }, [
          (format !== _ctx.formats[_ctx.formats.length - 1])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (! _ctx.highRes)
                  ? (_openBlock(), _createElementBlock("source", {
                      key: 0,
                      type: _ctx.getTypeByFormat(format),
                      "data-srcset": `${ _ctx.src }.${ format }`
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createElementBlock("source", {
                      key: 1,
                      type: _ctx.getTypeByFormat(format),
                      "data-srcset": `${ _ctx.src }.${ format }, ${ _ctx.src }@2x.${ format } 2x`
                    }, null, 8, _hoisted_3))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("img", {
        "data-src": `${ _ctx.src }.${ _ctx.formats[_ctx.formats.length - 1] }`,
        alt: _ctx.alt,
        title: _ctx.title
      }, null, 8, _hoisted_4)
    ])
  ], 512))
}